import React from "react";

import "./BulletItem.css";

export default class BulletItem extends React.Component {
  
  render() {
    
    const { className, cssModifier, children } = this.props;
    
    const classNames = [ "home-bullet-item" ];
    if (className !== undefined) {
      classNames.push(className);
    }
    if (cssModifier !== undefined) {
      classNames.push(`home-bullet-item--${cssModifier}`);
    }
    
    return (
      <div className={classNames.join(" ")}>
        <div className="home-bullet-item__bullet"></div>
        <div className="home-bullet-item__body">
          { children }
        </div>
      </div>
    )
    
  }
  
}



// WEBPACK FOOTER //
// ./src/components/app/home/BulletItem.js